import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from '../../shared/components/LinkButton';
import { PsRoutes } from '../../shared/routing/Routes';
import { I18nUtils } from '../../../i18n/I18nUtils';
import DateFormatter from '../../shared/utils/DateFormatter';
import RouterUtils from '../../shared/routing/RouterUtils';
import ActiveLabel from '../../shared/components/ActiveLabel';
import { connect } from 'react-redux';

class WorkRow extends React.Component {

    renderState(work) {
        if ( this.props.hideState ) {
            return null;
        }
        return <td><ActiveLabel state={work.construction_state}/></td>;
    }

    render() {
        const { work } = this.props;
        return (
            <tr>
                {this.renderState(work)}
                <td>{work.code}</td>
                <td><strong>{work.name}</strong></td>
                {this.props.showContractorColumn && <td>{work.contractor ? work.contractor.name : ''}</td>}
                <td>{DateFormatter.formatDate(work.start_date)}</td>
                <td>{DateFormatter.formatDate(work.end_date)}</td>
                <td>
                    <LinkButton
                        to={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_WORKS_DETAIL, { id: work.id })}
                        text={I18nUtils.tr('TR_VER_FICHA')} className={'btn-block btn-sm'}
                    />
                </td>
            </tr>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.auth.user,
    };
};

export default connect(mapStateToProps)(WorkRow);

WorkRow.propTypes = {
    work: PropTypes.objectOf(PropTypes.any).isRequired,
    hideState: PropTypes.bool,
    showContractorColumn: PropTypes.bool,
};

WorkRow.defaultProps = {
    hideState: false,
    showContractorColumn: false,
};



// WEBPACK FOOTER //
// ./src/app/works/components/WorkRow.js